export enum QueryKeys {
  MimVersion = 'mimVersion',
  GroupedAlerts = 'groupedAlerts'
}
